import { ListBox, YesNoButton } from '../../../../components';
import { FormFields, FormHeader, FormSection } from '../form';
import { useValidation } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { claimFields } from '../../../../config';

import type { Dispatch, FC, SetStateAction } from 'react';
import type { IListItem } from '../../../../types';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IDamagerOpinionProps {
  billableParties: Array<IListItem>;
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const DamagerOpinion: FC<IDamagerOpinionProps> = ({ billableParties, setSaveAndQuitChanges }) => {
  const formContext = useFormContext();
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  const hasOpinion: boolean | null = formContext.watch(claimFields.opinionOnResponsibleParty);

  const onHasOpinionNoClick = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, claimFields.opinionOnResponsibleParty]);
    formContext.setValue(claimFields.responsibleForDamage, 0);
    formContext.clearErrors(claimFields.responsibleForDamage);
  };

  const onHasOpinionYesClick = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, claimFields.opinionOnResponsibleParty]);
    formContext.setValue(claimFields.opinionOnResponsibleParty, true);
    formContext.clearErrors(claimFields.opinionOnResponsibleParty);
  };

  const onResponsibleForDamageChange = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, claimFields.opinionOnResponsibleParty]);
    formContext.setValue(claimFields.opinionOnResponsibleParty, true);
    formContext.clearErrors(claimFields.opinionOnResponsibleParty);
    formContext.clearErrors(claimFields.responsibleForDamage);
  };

  return (
    <FormSection>
      <FormHeader>{localization.translate('damagerOpinion.header')}</FormHeader>

      <FormFields>
        {/* HAS OPINION? */}
        <YesNoButton
          isSelected={hasOpinion}
          labelText={localization.translate('damagerOpinion.hasOpinionLabel')}
          name={claimFields.opinionOnResponsibleParty}
          onNoClick={onHasOpinionNoClick}
          onYesClick={onHasOpinionYesClick}
          tooltip={localization.translate('damagerOpinion.hasOpinionTooltip')}
        />

        {hasOpinion !== false && (
          <>
            {/* RESPONSIBLE PARTY */}
            <ListBox
              isRequired={fieldRequirements.ResponsibleForDamage}
              label={localization.translate('damagerOpinion.responsiblePartyLabel')}
              listItems={billableParties}
              name={claimFields.responsibleForDamage}
              onSingleChange={onResponsibleForDamageChange}
              tooltip={localization.translate('damagerOpinion.responsiblePartyTooltip')}
            />
          </>
        )}
      </FormFields>
    </FormSection>
  );
};